import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Flex,
  IconButton,
} from '@chakra-ui/react';
import React from 'react';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  ALERT_STATUS_TO_COLOR_SCHEME,
  SIZES,
} from '~/packages/common-frontend/theme';

// Constants
const COMPONENT_NAME = './chakra/Alert';

// Fragments
const RouteBase = () => (
  <PageTemplate title={COMPONENT_NAME}>
    <ComponentGridRenderer
      primaries={SIZES}
      primaryPropName="size"
      secondaries={['error', 'info', 'loading', 'success', 'warning'] as const}
      secondaryPropName="status"
      tertiaries={[null]}
      width="30rem"
    >
      {({ primary: size, secondary: status }) => (
        <Flex direction="column" flexGrow={1} gap="0.5rem">
          <Alert size={size} status={status}>
            <AlertIcon />
            Alert text
          </Alert>
          <Alert size={size} status={status}>
            <AlertIcon />
            <Flex direction="column">
              <AlertTitle>Alert title</AlertTitle>
              <AlertDescription>Alert description</AlertDescription>
            </Flex>
          </Alert>
          <Alert size={size} status={status}>
            <AlertIcon />
            <Flex direction="column" flexGrow={1}>
              <AlertTitle>Alert title</AlertTitle>
              <AlertDescription>Alert description</AlertDescription>
            </Flex>
            <Button
              alignSelf="flex-start"
              variant="link"
              colorScheme="blue"
              aria-label="Click me"
            >
              Click me
            </Button>
          </Alert>
          <Alert size={size} status={status}>
            <AlertIcon />
            <Flex direction="column" flexGrow={1}>
              <AlertTitle>Alert title</AlertTitle>
              <AlertDescription>Alert description</AlertDescription>
            </Flex>
            <IconButton
              alignSelf="flex-start"
              right="-0.4rem"
              top="-0.25rem"
              variant="v2-ghost"
              colorScheme={ALERT_STATUS_TO_COLOR_SCHEME[status]}
              size="sm"
              icon={<Icon icon="xmark-large" />}
              aria-label="Close"
            />
          </Alert>
        </Flex>
      )}
    </ComponentGridRenderer>
  </PageTemplate>
);

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
